/*
 * File: About.tsx
 * Project: a-a
 * File Created: Monday, 3rd November 2025 11:01:59 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 17th November 2025 11:45:51 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Skeleton, Typography, useTheme } from '@mui/material';
import React from 'react';
import zeplinColor from '../../../../../theme/Color';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import CustomAlert from '../../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../../shared/CustomAlert/CustomAlertContain';

const About = ({ data, loading }: { data: any; loading: boolean }) => {
  const theme = useTheme();
  console.log(data);
  const IMG_SRC = {
    LINKED_IN: '/assets/linkedin-link.png',
    INSTAGRAM: '/assets/instagram-link.png',
    TWITTER: '/assets/x-link.png',
    FACEBOOK: '/assets/facebook-link.png',
  };
  const [alert, setAlert] = React.useState('');
  const handleClose = () => {
    setAlert('');
  };
  const handleCopyLink = () => {
    // console.log(location);
    navigator.clipboard.writeText(data?.phone);
    setAlert(`Phone number copied successfully`);
  };
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: '20px', paddingBottom: { xs: '2rem' } }}
    >
      <Box sx={{ display: 'flex', gap: '12px', width: '58px', alignItems: 'center' }}>
        <img
          src={'/assets/zoominfo-tags.svg'}
          width={'20px'}
          height={'20px'}
          alt='zoominfo-about'
        />
        <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
          About
        </Typography>
      </Box>
      {loading ? (
        <Skeleton
          variant='text'
          sx={{
            fontSize: theme.typography.body2,
            width: '5rem',
            backgroundColor: zeplinColor.Neutral4,
            // Optionally adjust other styles here
          }}
        />
      ) : (
        <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
          {data?.descriptionList?.[0]?.description}
        </Typography>
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <img
            src={'/assets/zoominfo-about-social.svg'}
            width={'20px'}
            height={'20px'}
            alt='zoominfo-about-social'
          />
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
            Socials
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: '8px' }}>
          {data?.socialMediaUrls?.map(
            (val: any) =>
              val?.type &&
              val?.url && (
                <Link
                  to={`${val?.url}`}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{
                    color: zeplinColor.Neutral1,
                    textDecoration: 'none',
                  }}
                  // onClick={(e) =>
                  //   !profile?.facebook_profile_url && e.preventDefault()
                  // }
                >
                  <img
                    src={IMG_SRC[val?.type as keyof typeof IMG_SRC] || '/assets/x-link.png'}
                    width={'26px'}
                    height={'26px'}
                    alt='facebook'
                  />
                </Link>
              ),
          )}
          {/* <img src={'/assets/facebook.svg'} width={'26px'} height={'26px'} alt='facebook' />
          <img src={'/assets/facebook.svg'} width={'26px'} height={'26px'} alt='facebook' /> */}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <img
            src={'/assets/zoominfo-about-call.svg'}
            width={'20px'}
            height={'20px'}
            alt='zoominfo-about-call'
          />
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
            HQ phone
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <Typography variant='responsiveBody3' color={zeplinColor.Brand1}>
            {data?.phone}
          </Typography>
          <img
            onClick={handleCopyLink}
            src={'/assets/copy-link.svg'}
            width={'20px'}
            height={'20px'}
            alt='zoominfo-about-call'
          />
        </Box>
      </Box>
      {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <img
            src={'/assets/zoominfo-about-hierchy.svg'}
            width={'20px'}
            height={'20px'}
            alt='zoominfo-about-call'
          />
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
            Corporate hierarchy
          </Typography>
        </Box>
        <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
          Ultimate parent company, Subsidiaries & acquisitions: Air Jordan
        </Typography>
      </Box> */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <img
            src={'/assets/zoominfo-about-funding.svg'}
            width={'20px'}
            height={'20px'}
            alt='zoominfo-about-call'
          />
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
            Funding
          </Typography>
        </Box>
        {!data?.companyFunding?.length ? (
          <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
            NA
          </Typography>
        ) : (
          data?.companyFunding?.map((val: any) => (
            <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
              Funded {val?.amount || ''}{' '}
              {val?.investors.some((item: any) => item?.length) ? 'by' : ''}{' '}
              {val?.investors?.join(',') || ''}
            </Typography>
          ))
        )}
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <img
            src={'/assets/zoominfo-domain.svg'}
            width={'20px'}
            height={'20px'}
            alt='zoominfo-about-call'
          />
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
            Domain rank
          </Typography>
        </Box>
        <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
          {data?.domainRank}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <img
            src={'/assets/zoominfo-year-founded.svg'}
            width={'20px'}
            height={'20px'}
            alt='zoominfo-about-call'
          />
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
            Year founded
          </Typography>
        </Box>
        <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
          {data?.foundedYear || 'NA'}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <img
            src={'/assets/zoominfo-ticker.svg'}
            width={'20px'}
            height={'20px'}
            alt='zoominfo-about-call'
          />
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
            Ticker
          </Typography>
        </Box>
        <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
          {data?.ticker || 'NA'}
        </Typography>
      </Box>
      <CustomAlert
        open={alert ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alertIcon={
              !alert?.includes('successful') ? (
                <img src='/assets/error.svg' width={24} height={24} />
              ) : (
                <img src='/assets/checkmark-green.png' width={24} height={24} />
              )
            }
            alert={alert}
            error={alert && !alert?.includes('successful') ? true : false}
          />
        }
        error={alert && !alert?.includes('successful') ? true : false}
      />
    </Box>
  );
};

export default About;
